// 告警设置页
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Tooltip, Switch, message, Spin, InputNumber, Input } from "antd";
import { alarmset, alarmtypeset } from "@/api/newApi";
import classnames from "classnames";
import "./index.scss";
import effectImg from "../../assets/takeeffect.png";
import Area from "../../components/area";
import Analysisapi from "@/api/analysis";

const Pages = () => {
  const [alarmTypeList, setalarmTypeList] = useState([]); // 水质告警类型列表数据
  const [station, setStation] = useState([]);
  const [stationId, setStationId] = useState();
  const [spinLoading, setSpinLoading] = useState(false); // 水质告警类型设置的加载状态
  const [redAlarmData, setredAlarmData] = useState([]); // 红色告警基本数据
  const [ySettingData, setySettingData] = useState([]); // 黄色告警基本数据

  useEffect(() => {
    getStation();    
  }, []);

  useEffect(() => {
    if (stationId) {
      getSetListData();
      getAlarmTypeList();
    }
  }, [stationId]);

  // 获取水质告警类型列表
  const getAlarmTypeList = () => {
    setalarmTypeList([])
    alarmtypeset.selectList({ stationId }).then((res) => {
      if (res.status * 1 === 0) {
        setalarmTypeList(() => {
          return [...res.data]
        });
      }
    });
  };

  // 水质告警类型设置改变事件
  const changeAlarmTypeSet = (check, item) => {
    setSpinLoading(true);
    alarmtypeset
      .updateAlarmTypeSetSwitchById({
        id: item.id,
        switchOpen: check ? 1 : 0,
      })
      .then((res) => {
        setSpinLoading(false);
        if (res.status * 1 === 0) {
          message.success("设置成功。");
        }
      });
  };

  // 获取告警设置列表
  const getSetListData = () => {
    alarmset.selectList({ stationId }).then((res) => {
      if (res.status * 1 == 0) {
        let redAlarmData = [];
        let yellowAlarmData = [];
        res.data.map((mm) => {
          if (mm.alarmLevel == 2) {
            redAlarmData.push(mm);
          } else {
            yellowAlarmData.push(mm);
          }
        });
        setredAlarmData(redAlarmData);
        setySettingData(yellowAlarmData);
      }
    });
  };

  const getStation = () => {
    Analysisapi.getStation().then((res) => {
      if (res.status == 0 && res.data) {
        setStation(res.data);
        setStationId(res.data[0] ? res.data[0].id : null);
      }
    });
  };

  const getStationId = (id) => {
    setStationId(id);
  };

  // 设置红色告警标准生效
  const setRedSettingFn = (item) => {
    alarmset.updateRedAlarmSetById({ alarmSetId: item.id }).then((res) => {
      if (res.status * 1 === 0) {
        message.success("设置成功");
        getSetListData();
      }
    });
  };
  // 修改按钮
  const editBtn = (item, idx, type) => {
    const data = { ...item, isEdit: true };
    if (type == "red") {
      sessionStorage.setItem("cacherAlarmData", JSON.stringify(data));
      redAlarmData[idx].isEdit = true;
      setredAlarmData([...redAlarmData]);
    } else if (type == "yellow") {
      sessionStorage.setItem("cacheyAlarmData", JSON.stringify(data));
      ySettingData[idx].isEdit = true;
      setySettingData([...ySettingData]);
    }
  };

  // 取消按钮
  const cancelBtn = (idx, type) => {
    if (type == "red") {
      const data = JSON.parse(sessionStorage.getItem("cacherAlarmData"));
      data.isEdit = false;
      redAlarmData[idx] = data;
      setredAlarmData([...redAlarmData]);
    } else {
      const data = JSON.parse(sessionStorage.getItem("cacheyAlarmData"));
      data.isEdit = false;
      ySettingData[idx] = data;
      setySettingData([...ySettingData]);
    }
  };

  // 黄色报警恢复默认，默认值为已生效红色报警的70%
  const recoveryBtn = () => {
    let data = ySettingData[0];
    redAlarmData.map((mm) => {
      if (mm.standardName == "A标准") {
        let arr = [
          "codMin",
          "codMax",
          "tpMin",
          "tpMax",
          "tnMin",
          "tnMax",
          "nh3nsMin",
          "nh3nsMax",
          "nh3nwMin",
          "nh3nwMax",
        ];
        Object.keys(data).map((key) => {
          data.phMax = 8.5;
          data.phMin = 6.5;
          if (arr.indexOf(key) > -1) {
            data[key] = (mm[key] * 0.7).toFixed(2);
          }
        });
      }
    });
    saveBtn(data);
    setySettingData([data]);
  };

  // 黄色告警编辑保存按钮
  const saveBtn = (item) => {
    let data = { ...item };
    delete data.isEdit;
    alarmset.updateYellowAlarmSetById(data).then((res) => {
      if (res.status * 1 === 0) {
        message.success("操作成功。");
        getSetListData();
      }
    });
  };

  // 设置input框改变事件
  const iptChange = (value, idx, key, type) => {
    if (type === "red") {
      redAlarmData[idx][key] = value;
      setredAlarmData([...redAlarmData]);
    } else if (type == "yellow") {
      ySettingData[idx][key] = value;
      setySettingData([...ySettingData]);
    }
  };

  return (
    <div className="warnSetting-page baseContent">
      <div className="setting-page-title">告警设置</div>
      <div className="area" style={{ display: "flex" }}>
        <span
          style={{
            borderBottom: "1px solid #EEF0F3",
            padding: "11px 15px 12px 5px",
          }}
        >
          厂站:
        </span>
        <Area station={station} getStationId={getStationId} needAll={false} />
      </div>
      {/* 红色告警设置 */}
      <div className="setting-box">
        <div className="section-tit">
          出水水质
          <span className="red">红色</span>
          告警级别设置：
        </div>
        <div className="item-box">
          {redAlarmData.map((item, idx) => {
            return (
              <div
                className={classnames({
                  item: true,
                  on: item.takeEffect,
                })}
                key={idx}
              >
                <img className="finish-img" src={effectImg} alt="已完成" />
                <div className="tit">
                  <div className="box">
                    <i
                      className={classnames({
                        iconfont: true,
                        iconguobiao: idx == 0, //国标
                        icondibiao: idx != 0, //地标
                      })}
                    ></i>
                    <span>
                      {item.isEdit ? "编辑" : ""}
                      {item.standardName}
                    </span>
                  </div>
                  <div className="box">
                    {!item.isEdit && (
                      <Tooltip
                        title={
                          <div className="warn-setting-hover-tip">
                            <div onClick={() => editBtn(item, idx, "red")}>
                              修改
                            </div>
                            <div onClick={() => setRedSettingFn(item)}>
                              设置生效
                            </div>
                          </div>
                        }
                        placement="bottom"
                        color="#fff"
                        overlayClassName="warn-setting-tooltip"
                      >
                        <i className="iconfont iconshenglvehao"></i>
                      </Tooltip>
                    )}
                    {item.isEdit && (
                      <div className="btn-box">
                        <button
                          type="button"
                          onClick={() => cancelBtn(idx, "red")}
                        >
                          取消
                        </button>
                        <button type="button" onClick={() => saveBtn(item)}>
                          保存
                        </button>
                      </div>
                    )}
                  </div>
                </div>
                <div className="con">
                  <div className="data">
                    <div className="label">COD：</div>
                    <div className="val">
                      {!item.isEdit ? (
                        item.codMin + "-" + item.codMax
                      ) : (
                        <>
                          <InputNumber
                            value={item.codMin}
                            onChange={(value) =>
                              iptChange(value, idx, "codMin", "red")
                            }
                          />
                          -
                          <InputNumber
                            value={item.codMax}
                            onChange={(value) =>
                              iptChange(value, idx, "codMax", "red")
                            }
                          />
                        </>
                      )}
                    </div>
                  </div>
                  <div className="data">
                    <div className="label">TP：</div>
                    <div className="val">
                      {!item.isEdit ? (
                        item.tpMin + "-" + item.tpMax
                      ) : (
                        <>
                          <InputNumber
                            value={item.tpMin}
                            onChange={(value) =>
                              iptChange(value, idx, "tpMin", "red")
                            }
                          />
                          -
                          <InputNumber
                            value={item.tpMax}
                            onChange={(value) =>
                              iptChange(value, idx, "tpMax", "red")
                            }
                          />
                        </>
                      )}
                    </div>
                  </div>
                  <div className="data">
                    <div className="label">TN：</div>
                    <div className="val">
                      {!item.isEdit ? (
                        item.tnMin + "-" + item.tnMax
                      ) : (
                        <>
                          <InputNumber
                            value={item.tnMin}
                            onChange={(value) =>
                              iptChange(value, idx, "tnMin", "red")
                            }
                          />
                          -
                          <InputNumber
                            value={item.tnMax}
                            onChange={(value) =>
                              iptChange(value, idx, "tnMax", "red")
                            }
                          />
                        </>
                      )}
                    </div>
                  </div>
                  <div className="data">
                    <div className="label">NH3-N (夏)：</div>
                    <div className="val">
                      {!item.isEdit ? (
                        item.nh3nsMin + "-" + item.nh3nsMax
                      ) : (
                        <>
                          <InputNumber
                            value={item.nh3nsMin}
                            onChange={(e) =>
                              iptChange(e, idx, "nh3nsMin", "red")
                            }
                          />
                          -
                          <InputNumber
                            value={item.nh3nsMax}
                            onChange={(e) =>
                              iptChange(e, idx, "nh3nsMax", "red")
                            }
                          />
                        </>
                      )}
                    </div>
                  </div>
                  <div className="data">
                    <div className="label">NH3-N (冬)：</div>
                    <div className="val">
                      {!item.isEdit ? (
                        item.nh3nwMin + "-" + item.nh3nwMax
                      ) : (
                        <>
                          <InputNumber
                            value={item.nh3nwMin}
                            onChange={(e) =>
                              iptChange(e, idx, "nh3nwMin", "red")
                            }
                          />
                          -
                          <InputNumber
                            value={item.nh3nwMax}
                            onChange={(e) =>
                              iptChange(e, idx, "nh3nwMax", "red")
                            }
                          />
                        </>
                      )}
                    </div>
                  </div>
                  <div className="data">
                    <div className="label">PH：</div>
                    <div className="val">
                      {!item.isEdit ? (
                        item.phMin + "-" + item.phMax
                      ) : (
                        <>
                          <InputNumber
                            value={item.phMin}
                            onChange={(value) =>
                              iptChange(value, idx, "phMin", "red")
                            }
                          />
                          -
                          <InputNumber
                            value={item.phMax}
                            onChange={(value) =>
                              iptChange(value, idx, "phMax", "red")
                            }
                          />
                        </>
                      )}
                    </div>
                  </div>
                  <div className="data" style={{ width: "100%" }}>
                    <div className="label">告警推送地址</div>
                    <div className="val">
                      {!item.isEdit ? (
                        item.webhook
                      ) : (
                        <Input
                          placeholder="请输入告警推送地址"
                          value={item.webhook}
                          onChange={(e) =>
                            iptChange(e.target.value, idx, "webhook", "red")
                          }
                        />
                      )}
                    </div>
                  </div>
                </div>
                <div className="foot">
                  {item.gbName}{item.gbCode}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      {/* 黄色告警设置 */}
      <div className="y-warning-box setting-box">
        <div className="section-tit">
          出水水质
          <span>黄色</span>
          告警级别设置：
        </div>
        <div className="item-box">
          {ySettingData.map((item, idx) => {
            return (
              <div className="item" key={idx}>
                <div className="tit">
                  <div className="box">
                    <i className="iconfont iconzidingyibiaozhun"></i>
                    <span>{item.isEdit ? "编辑" : ""}黄色告警</span>
                  </div>
                  <div className="box">
                    {!item.isEdit && (
                      <Tooltip
                        title={
                          <div className="warn-setting-hover-tip">
                            <div onClick={() => editBtn(item, idx, "yellow")}>
                              修改
                            </div>
                            <div onClick={() => recoveryBtn()}>恢复默认</div>
                          </div>
                        }
                        placement="bottom"
                        color="#fff"
                        overlayClassName="warn-setting-tooltip"
                      >
                        <i className="iconfont iconshenglvehao"></i>
                      </Tooltip>
                    )}
                    {item.isEdit && (
                      <div className="btn-box">
                        <button
                          type="button"
                          onClick={() => cancelBtn(idx, "yellow")}
                        >
                          取消
                        </button>
                        <button type="button" onClick={() => saveBtn(item)}>
                          保存
                        </button>
                      </div>
                    )}
                  </div>
                </div>
                <div className="con">
                  <div className="data">
                    <div className="label">COD：</div>
                    <div className="val">
                      {!item.isEdit ? (
                        item.codMin + "-" + item.codMax
                      ) : (
                        <>
                          <InputNumber
                            value={item.codMin}
                            onChange={(e) =>
                              iptChange(e, idx, "codMin", "yellow")
                            }
                          />
                          -
                          <InputNumber
                            value={item.codMax}
                            onChange={(e) =>
                              iptChange(e, idx, "codMax", "yellow")
                            }
                          />
                        </>
                      )}
                    </div>
                  </div>
                  <div className="data">
                    <div className="label">TP：</div>
                    <div className="val">
                      {!item.isEdit ? (
                        item.tpMin + "-" + item.tpMax
                      ) : (
                        <>
                          <InputNumber
                            value={item.tpMin}
                            onChange={(e) =>
                              iptChange(e, idx, "tpMin", "yellow")
                            }
                          />
                          -
                          <InputNumber
                            value={item.tpMax}
                            onChange={(e) =>
                              iptChange(e, idx, "tpMax", "yellow")
                            }
                          />
                        </>
                      )}
                    </div>
                  </div>
                  <div className="data">
                    <div className="label">TN：</div>
                    <div className="val">
                      {!item.isEdit ? (
                        item.tnMin + "-" + item.tnMax
                      ) : (
                        <>
                          <InputNumber
                            value={item.tnMin}
                            onChange={(e) =>
                              iptChange(e, idx, "tnMin", "yellow")
                            }
                          />
                          -
                          <InputNumber
                            value={item.tnMax}
                            onChange={(e) =>
                              iptChange(e, idx, "tnMax", "yellow")
                            }
                          />
                        </>
                      )}
                    </div>
                  </div>
                  <div className="data">
                    <div className="label">NH3-N (夏)：</div>
                    <div className="val">
                      {!item.isEdit ? (
                        item.nh3nsMin + "-" + item.nh3nsMax
                      ) : (
                        <>
                          <InputNumber
                            value={item.nh3nsMin}
                            onChange={(e) =>
                              iptChange(e, idx, "nh3nsMin", "yellow")
                            }
                          />
                          -
                          <InputNumber
                            value={item.nh3nsMax}
                            onChange={(e) =>
                              iptChange(e, idx, "nh3nsMax", "yellow")
                            }
                          />
                        </>
                      )}
                    </div>
                  </div>
                  <div className="data">
                    <div className="label">NH3-N (冬)：</div>
                    <div className="val">
                      {!item.isEdit ? (
                        item.nh3nwMin + "-" + item.nh3nwMax
                      ) : (
                        <>
                          <InputNumber
                            value={item.nh3nwMin}
                            onChange={(e) =>
                              iptChange(e, idx, "nh3nwMin", "yellow")
                            }
                          />
                          -
                          <InputNumber
                            value={item.nh3nwMax}
                            onChange={(e) =>
                              iptChange(e, idx, "nh3nwMax", "yellow")
                            }
                          />
                        </>
                      )}
                    </div>
                  </div>
                  <div className="data">
                    <div className="label">PH：</div>
                    <div className="val">
                      {!item.isEdit ? (
                        item.phMin + "-" + item.phMax
                      ) : (
                        <>
                          <InputNumber
                            value={item.phMin}
                            onChange={(e) =>
                              iptChange(e, idx, "phMin", "yellow")
                            }
                          />
                          -
                          <InputNumber
                            value={item.phMax}
                            onChange={(e) =>
                              iptChange(e, idx, "phMax", "yellow")
                            }
                          />
                        </>
                      )}
                    </div>
                  </div>
                  <div className="data" style={{ width: "100%" }}>
                    <div className="label">告警推送地址</div>
                    <div className="val">
                      {!item.isEdit ? (
                        item.webhook
                      ) : (
                        <Input
                          placeholder="请输入告警推送地址"
                          value={item.webhook}
                          onChange={(e) =>
                            iptChange(e.target.value, idx, "webhook", "yellow")
                          }
                        />
                      )}
                    </div>
                  </div>
                </div>
                {/* <div className="foot">默认为一级A标的70%</div> */}
              </div>
            );
          })}
        </div>
      </div>
      {/* 水质告警类型设置 */}
      <div className="type-setting-box">
        <div className="tit">水质告警类型设置：</div>
        <Spin spinning={spinLoading} tip="更新中...">
          <div className="radio-group-box">
            {alarmTypeList.map((mm, idx) => {
              return (
                <div className="item" key={idx}>
                  <span>{mm.alarmTypeName}</span>
                  <Switch
                    checkedChildren="开"
                    unCheckedChildren="关"
                    onChange={(check) => changeAlarmTypeSet(check, mm)}
                    defaultChecked={mm.switchOpen == 1}
                  />
                </div>
              );
            })}
          </div>
        </Spin>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    ...state.Common,
  };
};

export default connect(mapStateToProps)(Pages);
